var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfiniAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 30,
    viewBox: "0 0 66 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0481 19.3313C25.8351 21.3909 23.4902 23.354 20.8041 24.7407C18.118 26.1275 15.0464 26.9129 12.051 26.5014C8.19586 25.9717 4.69098 23.3597 3.08183 19.8178C1.47268 16.2759 1.81384 11.919 3.95407 8.67034C4.43511 7.93945 5.00485 7.26995 5.64168 6.67206C8.61207 3.89515 12.888 2.96648 16.8045 4.05542C28.7259 7.38362 35.5048 20.8271 46.8473 25.8046C48.6066 26.5594 50.5648 27.1096 52.4924 27.1516C62.1348 27.4256 67.3728 14.5083 61.3729 7.11536C59.1758 4.31458 55.6652 2.73801 52.1194 2.8494C48.9341 2.94602 46.0751 4.25093 43.3629 5.91503C41.2284 7.2188 39.4259 8.87153 37.7997 10.7198",
    stroke: "#4289D5",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfiniAiIcon);
export default __webpack_public_path__ + "static/media/infiniAiIcon.534a41aa5b37a3171f938896a93eb1f4.svg";
export { ForwardRef as ReactComponent };